import { render, staticRenderFns } from "./DataOverview.vue?vue&type=template&id=91350c2a&scoped=true"
import script from "./DataOverview.vue?vue&type=script&lang=ts"
export * from "./DataOverview.vue?vue&type=script&lang=ts"
import style0 from "./DataOverview.vue?vue&type=style&index=0&id=91350c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91350c2a",
  null
  
)

export default component.exports